import { autorun, makeAutoObservable, runInAction } from 'mobx';
import {
  getAllDevicesModels,
  deleteDeviceModel,
  createDeviceModel,
  updateDeviceModel,
  getDevicesModelsIcons,
} from 'services/devicesModels.services';
import { getListDeviceModels } from 'services/list.services';

const NAME = 'devicesModels-store';

export class DevicesModelsStore {
  devicesModels = [];
  listDevicesModels = [];
  stateDeviceModel = null;

  pagination = {
    itemsCount: 0,
    limit: 0,
    page: 1,
    pagesCount: 1,
  };
  columns = [];
  icons = [];

  constructor() {
    makeAutoObservable(this);

    const storeJSON = localStorage.getItem(NAME);

    if (storeJSON) Object.assign(this, JSON.parse(storeJSON));

    autorun(() => {
      const obj = JSON.parse(JSON.stringify(this));
      localStorage.setItem(NAME, JSON.stringify(obj));
    });

    window.addEventListener('storage', this._updateStore);
  }

  _updateStore = (e) => {
    if (e.key === NAME) {
      const storeJSON = localStorage.getItem(NAME);

      if (storeJSON) Object.assign(this, JSON.parse(storeJSON));
    }
  };

  _dispose = () => {
    window.removeEventListener('storage', this._updateStore);
  };

  _prepareDeviceModelData = (deviceModelData) => {
    return {
      name: deviceModelData.name,
      description: deviceModelData.description,
      image: deviceModelData.image,
      user_fields: deviceModelData.user_fields?.map((user_field, index) => ({
        id: user_field.id,
        order: index,
      })),
      specifications: deviceModelData.specifications?.map((spec, index) => ({
        name: spec.name,
        value: spec.value,
        order: index,
      })),
    };
  };

  upsertDeviceModel = async () => {
    const preparedData = this._prepareDeviceModelData(this.stateDeviceModel);
    let res;

    if (this.stateDeviceModel?.id) {
      res = await updateDeviceModel(this.stateDeviceModel.id, preparedData);
    } else {
      res = await createDeviceModel(preparedData);
    }

    this.setDevicesModels();
    this.getListDevicesModels();
    return res;
  };

  getListDevicesModels = async () => {
    const response = await getListDeviceModels();

    runInAction(() => {
      this.listDevicesModels = response.data;
    });
  };

  setDevicesModels = async (options) => {
    const response = await getAllDevicesModels(options);

    runInAction(() => {
      this.devicesModels = response.data;
      this.pagination = {
        page: response?.pagination?.page,
        pagesCount: response?.pagination?.pages_count,
        itemsCount: response?.pagination?.items_count,
        limit: response?.pagination?.limit,
      };
      this.columns = response?.table;
    });
  };

  setStateDeviceModel = (deviceModel) => {
    runInAction(() => {
      this.stateDeviceModel = deviceModel;
    });
  };

  removeDeviceModel = async (id) => {
    const res = await deleteDeviceModel(id);

    if (res.success) {
      this.getListDevicesModels();
      this.setDevicesModels(this.pagination);
    }
    return res;
  };

  setIcons = async () => {
    const response = await getDevicesModelsIcons();

    runInAction(() => {
      this.icons = response.data;
    });
  };
}

export const devicesModelsStore = new DevicesModelsStore();
